export default "__VITE_PUBLIC_ASSET__99089084__"